import React, { Component } from "react";

import RecommendationView from "features/new/recommendation/component/view";

import barrons from "assets/graphics/icons/barrons.svg";
import vogue from "assets/graphics/icons/vogue.svg";
import gotham from "assets/graphics/icons/gotham.png";
import hauteLiving from "assets/graphics/icons/haute-living.svg";

class Recommendation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      recommendations: [
        {
          content: "We are entering a new golden age of social clubs",
          author_name: "Barron's",
          author_image_url: barrons,
          quotation_mark_position: "bottom",
        },
        {
          content:
            "Parlor’s data-forward platform utilizes technology to inform each member’s experience",
          author_name: "Haute Living",
          author_image_url: hauteLiving,
          quotation_mark_position: "bottom",
        },
        {
          content:
            "The new Parlor app and event-based schedule is really impressive",
          isMember: true,
          author_name: "Member - Actor, writer, producer",
          quotation_mark_position: "top",
        },
        {
          content:
            "Vogue kicked off fashion week in full force with a special VIP night",
          author_name: "Vogue",
          author_image_url: vogue,
          quotation_mark_position: "bottom",
        },
        {
          content:
            "A unique social member club designed for the realities of today",
          author_name: "Gotham",
          author_image_url: gotham,
          quotation_mark_position: "bottom",
        },
        {
          content:
            "I've met a lot of interesting people. It's a really cool way to socialize",
          isMember: true,
          author_name: "Member - VC",
          quotation_mark_position: "top",
        },
      ],
    };

    this.recommendationReference = React.createRef();
  }

  componentDidMount() {
    window.addEventListener("resize", () => {
      this.setRecommendationSpace();
    });
    this.setRecommendationSpace();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", () => {
      this.setRecommendationSpace();
    });
  }

  setRecommendationSpace() {
    if (this.recommendationReference.current) {
      let recommendation = this.recommendationReference.current;

      if (document.body.clientWidth < 1024) {
        document.querySelector(".main__experience") &&
          (document.querySelector(".main__experience").style.paddingTop = `${
            recommendation.clientHeight * 0.8
          }px`);
      } else {
        document.querySelector(".main__experience") &&
          (document.querySelector(".main__experience").style.paddingTop = `${
            recommendation.clientHeight * 0.5
          }px`);
      }
    }
  }

  render() {
    return (
      <RecommendationView
        recommendations={this.state.recommendations}
        recommendationReference={this.recommendationReference}
      />
    );
  }
}

export default Recommendation;
